module.exports = __webpack_public_path__ + "img/4.76239678.png";